<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                        v-if="spinner" size="72" indeterminate></v-progress-circular>
                    <v-card v-if="!hasQRCode && !spinner">
                        <v-card-title style="padding-top:12px; padding-bottom:6px;">
                            Take A Payment
                        </v-card-title>
                        <v-card-text style="padding-bottom: 0px;">
                            <p>Click the button below, a unique one time code will appear.</p>
                            <p>The customer can scan it to get a payment link.</p>

                        </v-card-text>
                        <v-alert class="alerts" v-if="!isCheckedIn" outlined
                            :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'" icon="mdi-airplane-check" dense
                            text>
                            Before taking a payment, you must first check-in to a club.
                        </v-alert>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!-- Add a computed value -->
                            <v-btn v-if="isCheckedIn" v-on:click="getPaymentQrCode" class="float-right"
                                :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"> Get QR Code</v-btn>
                            <v-btn v-if="!isCheckedIn" v-on:click="goToCheckIn" class="float-right"
                                :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"> Check In</v-btn>
                        </v-card-actions>
                    </v-card>

                    <v-card v-if="hasQRCode && !spinner">
                        <v-card-title style="padding-top:12px; padding-bottom:6px;">
                            Scan The Below Code
                        </v-card-title>
                        <v-card-text style="padding-bottom: 0px;">
                            <v-img max-height="450" max-width="450" :src="qrCodeUrl"></v-img>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-on:click="getPaymentQrCode" class="float-right"
                                :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"> Get New Code
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import moment from 'moment';
import RestResource from '../RestResource.js';
import accessHelper from '@/mixins/accessHelper.js';
import { mapGetters } from 'vuex';
const restResourceService = new RestResource();
export default ({
    name: "MyAccountPage",
    components: {

    },
    mixins: [accessHelper],
    props: {
    },
    data: () => ({

        spinner: false,
        hasQRCode: false,
        qrCodeUrl: '',
        chosenColor: localStorage.getItem(process.env.VUE_APP_THEME),
    }),
    computed: {
        isCheckedIn() {
            if(this.getAccount.lastCheckedInDate == null) return false;
            let lastCheckInDate = moment(this.getAccount.lastCheckedInDate);
            let now = moment();
            if (Math.abs(lastCheckInDate.diff(now, "hours")) > 10) return false; else return true;
        },
        ...mapGetters(['getAccount'])
    },
    mounted: function () {

    },
    methods: {
      

        async getPaymentQrCode() {
            this.spinner = true;
            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                this.qrCodeUrl = dataURL;
                console.log("QR URL IS " + this.qrCodeUrl);

            }
            const variability = new Date().getTime();
            img.src = restResourceService.getBaseUrl() + "partner/paymentlink?d="+variability;

            this.hasQRCode = true;
            this.spinner = false;
        },

        goToCheckIn() {
            this.$router.push({ path: '/Checkin' });
        }

    },
})
</script>

<style scoped>
</style>